import { render, staticRenderFns } from "./PresentationDetail.vue?vue&type=template&id=cf997d64&scoped=true&"
import script from "./PresentationDetail.vue?vue&type=script&lang=js&"
export * from "./PresentationDetail.vue?vue&type=script&lang=js&"
import style0 from "./PresentationDetail.vue?vue&type=style&index=0&id=cf997d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf997d64",
  null
  
)

export default component.exports